import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditCamps = () => {
  return (
    <Edit
      title="Редакция на лагер"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditCamps;
